






import { Vue, Component } from 'vue-property-decorator'
import Landing from '@/components/Landing.vue'

@Component({
  components: {
    Landing
  }
})
export default class Home extends Vue {
  created () {
    const token = localStorage.getItem('emailToken')

    // if accessed before, redirect using saved email token
    if (token) {
      this.$router.push({
        name: 'go',
        params: { token }
      })
    }
  }
}
